import { findCountry, matchDial, type PhoneCountry } from './countries.js';
import { normalisePhone } from './normalise.js';

/** Group sizes for a national number, by country and by length. */
function groups(c: PhoneCountry | undefined, n: number): number[] {
  const iso = c?.iso ?? '';
  if (c?.dial === '1' && n === 10) return [3, 3, 4];
  if (iso === 'ZA' && n === 9) return [2, 3, 4];
  if ((iso === 'GB' || iso === 'GG' || iso === 'JE' || iso === 'IM') && n === 10) return [4, 6];
  if (iso === 'NG' && n === 10) return [3, 3, 4];
  if (iso === 'KE' && n === 9) return [3, 3, 3];
  if (iso === 'AU' && n === 9) return [3, 3, 3];
  if (iso === 'FR' && n === 9) return [1, 2, 2, 2, 2];
  if (iso === 'IN' && n === 10) return [5, 5];
  if (n <= 4) return [n];
  if (n === 5) return [2, 3];
  if (n === 6) return [3, 3];
  if (n === 7) return [3, 4];
  if (n === 8) return [4, 4];
  if (n === 9) return [3, 3, 3];
  if (n === 10) return [3, 3, 4];
  if (n === 11) return [3, 4, 4];
  if (n === 12) return [3, 3, 3, 3];
  return [3, 3, 3, n - 9];
}

/**
 * The canonical form written for people: `+27615360809` → `+27 61 536 0809`.
 * Anything that is not a readable number comes back unchanged, so a list can
 * call this on every row without checking first.
 */
export function formatPhone(value: string | null | undefined, defaultCountry?: string | null): string {
  if (!value) return '';
  const r = normalisePhone(value, defaultCountry);
  if (!r.ok) return value;
  const c = findCountry(r.country) ?? matchDial(r.dialCode);
  const parts: string[] = [];
  let at = 0;
  for (const g of groups(c, r.national.length)) {
    if (at >= r.national.length) break;
    parts.push(r.national.slice(at, at + g));
    at += g;
  }
  if (at < r.national.length) parts.push(r.national.slice(at));
  return `+${r.dialCode} ${parts.join(' ')}`;
}
